import { registerStore } from '@wordpress/data';

const DEFAULT_STATE = {
	options: optionsKitValues || {},
	notSaved: false,
	active: {
		tab: 0,
		subTabs: {},
	}
};

const actions = {
	activeTab( index ) {
		return {
			type: 'ACTIVE_TAB',
			index,
		};
	},
	activeSubTab( index, tabId ) {
		return {
			type: 'ACTIVE_SUB_TAB',
			index,
			tabId,
		};
	},
	updateOption( id, value ) {
		return {
			type: 'UPDATE_OPTION',
			id,
			value,
		};
	},
	resetOptions() {
		return {
			type: 'RESET_OPTIONS',
		};
	},
	updateNotSaved( status ) {
		return {
			type: 'UPDATE_NOT_SAVED',
			status,
		};
	},
};

const selectors = {
	getActiveTab( { active } ) {
		return active.tab;
	},
	getActiveSubTabs( { active } ) {
		return active.subTabs;
	},
	getOptionValue( { options }, id, defaultValue ) {
		if ( options[id] === undefined ) {
			return defaultValue;
		}

		return options[id];
	},
	getAllOptions( { options } ) {
		return options;
	},
	getNotSaved( { notSaved } ) {
		return notSaved;
	}
};

registerStore( 'options-kit', {
	reducer( state = DEFAULT_STATE, action ) {
		switch ( action.type ) {
            case 'ACTIVE_TAB':
                return {
                    ...state,
                    active: {
						...state.active,
						tab: action.index,
                    },
                };
            case 'ACTIVE_SUB_TAB':
                return {
                    ...state,
                    active: {
						...state.active,
						subTabs: {
							...state.active.subTabs,
							[action.tabId]: action.index,
						}
                    },
                };
            case 'UPDATE_OPTION':
                return {
					...state,
					notSaved: true,
                    options: {
						...state.options,
						[action.id]: action.value,
                    },
                };
            case 'UPDATE_NOT_SAVED':
                return {
					...state,
					notSaved: action.status,
                };
            case 'RESET_OPTIONS':
                return {
					...state,
					notSaved: false,
                    options: {},
                };
        }
 
        return state;
	},
	actions,
	selectors,
} )